/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  buildCacheKey,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";

const basePath = `${referenceService}`;

/** Get All Reference Activated  */
export const getReferenceAll = async (ref: any, params: any): Promise<any> => {
  const cacheKey = buildCacheKey(`ref_${ref}`, params);
  const cached = getCache(cacheKey);
  if (cached) return cached;

  try {
    let response: any = await api.get<any>(`${basePath}/${ref}`, {
      params,
    });
    const data = response?.data?.return;
    if (data) setCache(cacheKey, data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Get All Bank Activated  */
type activatedParams = {
  activated: number;
};
export const getBank = async (params: activatedParams) => {
  const cacheKey = buildCacheKey("bank", params);
  const cached = getCache(cacheKey);
  if (cached) return cached;

  try {
    const response = await api.get<any>(`${basePath}/bank`, { params });
    const data = response?.data?.return;
    if (data) setCache(cacheKey, data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Get All Tipe Penerima Activated  */

export const getTipePenerima = async (params: activatedParams) => {
  const cacheKey = buildCacheKey("tipe-penerima", params);
  const cached = getCache(cacheKey);
  if (cached) return cached;

  try {
    const response = await api.get<any>(`${basePath}/tipe-penerima`, {
      params,
    });
    const data = response?.data?.return;
    if (data) setCache(cacheKey, data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Invalidate reference cache */
export const invalidateReferenceCache = (ref: string) => {
  removeCacheByPrefix(`ref_${ref}`);
};
